// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__2dfdn","colMaxWidth":"Table_colMaxWidth__1kWlG"};